module.exports = __webpack_public_path__ + "static/img/simulate_capital.8223740.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/simulate_capital.png
// module id = jKRF
// module chunks = 3